// camelCase converter
function toCamelCase(str) {
	if (!str || typeof str !== 'string') return null;

	return (
		str
			.toLowerCase()
			.trim()
			// remove apostrophes (ski's → skis)
			.replace(/'/g, '')
			// handle slash: merge words (boxes/others → boxesothers)
			.replace(/\//g, '')
			// remove any other unwanted chars except space & numbers
			.replace(/[^a-z0-9 ]/g, '')
			// normalize spaces
			.replace(/\s+/g, ' ')
			.split(' ')
			.filter(Boolean)
			.map((word, i) => {
				if (i === 0) return word;
				return word.charAt(0).toUpperCase() + word.slice(1);
			})
			.join('')
	);
}

export { toCamelCase };
